"use client";

import useItem from "hooks/useItem";
import AlertsContext from "providers/AlertProvider";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  collectionName: string;
  id?: string | number;
  Form: React.ComponentType<any>;
  onSubmitSuccess?: () => void;
  onBack?: () => void;
  populate?: string | object;
}

function CrudEdit({
  collectionName,
  id,
  Form,
  onSubmitSuccess,
  onBack,
  populate,
}: Props) {
  const { t } = useTranslation();
  const { setAlert } = useContext(AlertsContext);

  const { saveItem, updateItem, item, fetchItem, error, isFetching }: any =
    useItem(collectionName, id ? id?.toString() : null, { populate });

  useEffect(() => {
    if (error) {
      // This needs to change
      setAlert(
        error === "Username already taken"
          ? t("common.usernameAlreadyTaken")
          : error === "Email already taken"
          ? t("common.emailAlreadyTaken")
          : t("common.error"),
        "danger"
      );
    }
  }, [error, setAlert, t]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      onBack?.();
    }
  }, [error, setAlert, t, onBack]);

  const onSubmit = useCallback(
    async (data: any) => {
      try {
        const newItem = { ...data };

        const res = newItem.data.id
          ? await updateItem(id, newItem, false)
          : await saveItem(newItem, false);

        onSubmitSuccess?.();
        back();

        return res;
      } catch (e: any) {
        console.error(e);
        return e;
      }
    },
    [saveItem, updateItem, id, onSubmitSuccess, back]
  );

  return isFetching ? null : (
    <Form
      onSubmit={onSubmit}
      onCancel={onBack}
      item={item}
      fetchItem={fetchItem}
    />
  );
}

export default CrudEdit;
